import { version } from '../version';

window.global ||= window;

// n.b. there is a mock for these in the testing setup.js add any props there as well with test values
export const env = {
  // environment vars from config are prefixed with VITE_
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_BASE_URL: import.meta.env.VITE_BASE_URL,
  VITE_PLATFORM_REST_ENDPOINT: import.meta.env.VITE_PLATFORM_REST_ENDPOINT,
  VITE_CHECKOUT_DOMAIN: import.meta.env.VITE_CHECKOUT_DOMAIN,
  VITE_PLATFORM_URL: import.meta.env.VITE_PLATFORM_URL,
  VITE_STOREFRONT_URL: import.meta.env.VITE_STOREFRONT_URL,
  VITE_AUTH_TOKEN_KEY: import.meta.env.VITE_AUTH_TOKEN_KEY,
  VITE_AUTH0_CLAIMS_NAMESPACE: import.meta.env.VITE_AUTH0_CLAIMS_NAMESPACE,
  VITE_SERVER_EVENTS_PREFIX: import.meta.env.VITE_SERVER_EVENTS_PREFIX,
  VITE_PACKAGE_VERSION: version,
  VITE_FEATURE_FLAG_HIDE_TYPE: import.meta.env.VITE_FEATURE_FLAG_HIDE_TYPE,
  VITE_CORS_PROXY: import.meta.env.VITE_CORS_PROXY,
  VITE_AMPLITUDE_CLIENT_KEY: import.meta.env.VITE_AMPLITUDE_CLIENT_KEY,
  VITE_AMPLITUDE_API_KEY: import.meta.env.VITE_AMPLITUDE_API_KEY,
  VITE_FEATURE_SENTRY_ENABLED: import.meta.env.VITE_FEATURE_SENTRY_ENABLED,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: import.meta.env.VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED,
  VITE_SENTRY_INGEST_URL: import.meta.env.VITE_SENTRY_INGEST_URL,
  // other global settings go here
  DEFAULT_PAGE_SIZE: 20,
};

export const DECIMAL_PLACES = 2;
